import { Liveblog } from './LiveblogContent';
import { MultimediaContent } from './MultimediaContent';
import { WrittenContent } from './WrittenContent';

export type EditorialContent = WrittenContent | MultimediaContent | Liveblog;